module.exports = __webpack_public_path__ + "static/media/rpfpc_header_image.de3f21b5.jpg";